import { render, staticRenderFns } from "./EditBlog.vue?vue&type=template&id=54a7981a"
import script from "./EditBlog.vue?vue&type=script&lang=js"
export * from "./EditBlog.vue?vue&type=script&lang=js"
import style0 from "./EditBlog.vue?vue&type=style&index=0&id=54a7981a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports